export class FileUtils {
    static downloadFile(blob: Blob, fileName: string) {
        const downloadURL = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(downloadURL);
    }

    static async printFile(blob: Blob): Promise<void> {
        const fileURL = URL.createObjectURL(blob);
        const printWindow = window.open(fileURL);

        if (printWindow) {
            printWindow.onload = () => {
                printWindow.print();
                URL.revokeObjectURL(fileURL);
            };
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/core/utilities/fileUtils.ts